export default __webpack_public_path__ + "static/media/gallery_04.ec31b6d9.jpg";